/**
 * Checks to see if user is authenticated or not
 * @returns {Boolean}
 */
const isAuthenticated = () => {
  const isAuthenticated = document.body.getAttribute(
    'data-auth-is-authenticated'
  )
  const result = isAuthenticated === 'true'
  return result
}

/**
 * Gets the sign in auth url
 * @returns {String}
 */
const getAuthUrl = () => {
  const result = document.body.getAttribute('data-auth-url')
  return result
}

/**
 * Gets the signed in user ID
 * @returns {Number}
 */
const getUserId = () => {
  const result = window.rentler.userId
  return result
}

export { isAuthenticated, getAuthUrl, getUserId }
